<template>
    <div class="input-group">
        <div class="input-group-prepend" v-if="prepend && icon">
            <span class="input-group-text">
                <i :class="icon"></i>
            </span>
        </div>
        <slot>

        </slot>
        <div v-if="append" class="input-group-append">
            <slot name="append">

            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'input-group',
    props: {
        icon: {
            type: String,
            required: false
        },
        prepend: {
            type: Boolean,
            default: true
        },
        append: {
            type: Boolean,
            default: false
        }
    }
};
</script>
